export type TranslateFn = (key: string, values?: Record<string, string | number>) => string;

export function isMessageKey(key: string): boolean {
  return key.includes(".");
}

export function resolveNavLabel(
  t: TranslateFn,
  options: { labelKey?: string | null; fallbackLabel: string },
): string {
  const labelKey = options.labelKey?.trim();
  if (!labelKey) {
    return options.fallbackLabel;
  }
  const translated = t(labelKey);
  if (translated !== labelKey) {
    return translated;
  }
  if (isMessageKey(labelKey)) {
    return options.fallbackLabel;
  }
  return labelKey;
}

const NAV_SECTION_MESSAGE_KEYS: Record<string, string> = {
  intake: "navSection.intake",
  customer: "navSection.customer",
  conversations: "navSection.conversations",
  "party-master": "navSection.partyMaster",
  "supplier-ops": "navSection.supplierOps",
  "partner-ops": "navSection.partnerOps",
  work: "navSection.work",
  strategy: "navSection.strategy",
  contracts: "navSection.contracts",
  finance: "navSection.finance",
  hrm: "navSection.hrm",
  "policy-rules": "navSection.policyRules",
  "ai-safety": "navSection.aiSafety",
  "template-governance": "navSection.templateGovernance",
  "platform-administration": "navSection.platformAdministration",
  "context-governance": "navSection.contextGovernance",
  knowledge: "navSection.knowledgePlatform",
  observability: "navSection.observability",
  templates: "navSection.templates",
  rules: "navSection.rules",
  workspace: "navSection.workspace",
  administration: "navSection.administration",
};

export function resolveNavSectionLabel(t: TranslateFn, sectionId: string): string {
  const messageKey = NAV_SECTION_MESSAGE_KEYS[sectionId];
  if (!messageKey) {
    return sectionId;
  }
  return resolveNavLabel(t, { labelKey: messageKey, fallbackLabel: sectionId });
}
